import { render, staticRenderFns } from "./UserOnboarding.vue?vue&type=template&id=65a9a2e5&scoped=true"
import script from "./UserOnboarding.vue?vue&type=script&lang=js"
export * from "./UserOnboarding.vue?vue&type=script&lang=js"
import style0 from "./UserOnboarding.vue?vue&type=style&index=0&id=65a9a2e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a9a2e5",
  null
  
)

export default component.exports